// w10.js
import React from 'react';
import WW from './ww';
import { pageConfigs } from '../../configs';

const W10 = () => {
  return <WW config={pageConfigs.w10} />;
};

export default W10;
